window.openTab = function (evt, tabID) {
    var i, tabcontent, tablinks;
    tabcontent = document.querySelectorAll(".accordion");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.querySelectorAll(".accordion-tab");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    document.querySelector('.accordion[data-accordion-id="' + tabID + '"]').style.display = "block";
    evt.currentTarget.className += " active";
}

let preOpenAcc = document.querySelectorAll(".accordion-tab.open");

if (preOpenAcc.length) {
    for (let i = 0; i < preOpenAcc.length; i++) {
        preOpenAcc[i].click();
    }
}


// WEBPACK FOOTER //
// ./scripts/components/tabs.js